import React from "react";
import { Helmet } from "react-helmet-async";

const Aboutus = () => {
  const handleClick = (paths) => {
    window.open(`https://order.wheatbakes.com/onlineorder/`, "_blank");
  };

  return (
    <>
    <Helmet>
        <title>About WheatBakes | Natural Cake Makers in Chennai</title>
        <meta
          name="description"
          content="Know our story of 100% natural, no-maida, preservative-free cakes. Healthy whole wheat & eggless treats baked fresh in Chennai."
        />
        <link rel="canonical" href="https://wheatbakes.com/about-us" />

      </Helmet>
      
    <div> 

        {/* <section className="page-banner overflow-hidden">
            <div class="banner-bg">
            </div>

            <div className="container">
                <div className="row align-items-center">
                    <div class="col-xl-8 col-lg-8 col-md-12">
						<div class="page-banner-content">
							<h1>About Us</h1>
						</div>
					</div>

                    <div class="col-xl-4 col-lg-4 col-md-12">
						<div class="wheatbakes-breadcrumb">	
							<ul>
								<li><a href="/">Home</a></li>
								<li>About us</li>
							</ul>
						</div>
					</div>
                </div>
            </div>
        </section> */}

      <div className="container my-4">
        <div className="standards row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-12 order-t-1 image-padding" data-aos="fade-right">
            <img className="img-fluid" src="images/about.png" alt="logo" />
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12 order-t-2" data-aos="fade-left">
            <div className="heading">
              <p className="text-uppercase mt-3">The “WheatBakes” Story</p>

              <h1 className="mb-4">Why We Exist?</h1>
            </div>

            <div className="content">
              <p className="fw-semibold wheatbakes-para-justify">
                At Wheat Bakes, we are dedicated to redefining the dessert
                experience with our natural and healthy cakes. Crafted with
                whole wheat flour, jaggery, and millets, our cakes are designed
                to nourish while delivering exceptional flavors. From eggless
                cakes for vegetarians to homemade cakes baked without
                preservatives, every creation reflects our commitment to health
                and taste.
              </p>

              <p className="fw-semibold wheatbakes-para-justify">
                We specialize in guilt-free brownies, sugarless cakes, and wheat
                cupcakes that satisfy your sweet cravings without compromising
                your well-being. By avoiding refined sugar, maida, and harmful
                additives, we focus on using natural ingredients like pure
                couverture chocolate, nuts, and fresh fruits to create desserts
                that delight and inspire healthier lifestyles.
              </p>
            </div>

            <div className="my-5">
              <button className="wheatbakes-btn" onClick={()=>handleClick("onlineorder")}>EAT HEALTHY CAKES NOW</button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-text-image-card py-4">
        <div className="container my-3">
          <div className="standards row">
            <div className="col-xl-7 col-lg-7 col-md-12 order-t-1" data-aos="fade-right">
              <div className="heading">
                <p className="text-uppercase m-0">The name says it all!</p>

                <h1 className="mb-4">Why Wheat Bakes?</h1>
              </div>

              <div className="content">
                <p className="wheatbakes-para-justify">
                  At Wheat Bakes, we proudly offer <strong>whole wheat cakes</strong> as a healthy alternative to maida, packed with nutrients and fiber. We use <strong>whole wheat flour</strong> to make our cakes both <strong>healthy</strong> and <strong>tasty</strong>, with options like <strong>eggless whole wheat</strong> cakes and <strong>wheat and jaggery cakes</strong>.
                </p>

                <p className="wheatbakes-para-justify">
                  <strong>For your conscious cravings, we ethically source the best ingredients. Whether it's rich chocolate, fresh fruits,</strong> or <strong>nuts</strong>, we ensure that all our ingredients are natural and of the highest quality, without compromising taste.
                </p>

                <p className="wheatbakes-para-justify">
                  We focus on <strong>natural ingredients</strong>, avoiding artificial flavoring. Instead, we use <strong>fresh fruits</strong> and <strong>nutsto</strong> add authentic flavor to our <strong>healthy cakes</strong>.
                </p>

                <p className="wheatbakes-para-justify">
                  Eating natural isn't just a trend—it's a return to tradition. Wonder why our ancestors lived long and healthy lives? It's no secret! Step away from processed food and choose to eat <strong>natural and healthy</strong>, especially at Wheat Bakes, your go-to <strong>cake shop in T. Nagar</strong> for <strong>guilt-free cakes, millet cakes,</strong> and more!
                </p>
              </div>
              
            </div>

            <div className="col-xl-5 col-lg-5 col-md-12 order-t-2 image-padding" data-aos="fade-left">
              <img src="images/about-1.png" width="100%" alt="about" />
            </div>
          </div>
        </div>
      </div>

      <div className="container my-4">
        <div className="standards row align-items-center">
          <div className="col-xl-5 col-lg-5 col-md-12 order-t-2 text-center image-padding" data-aos="fade-right">
            <img className="img-fluid image-shadow" src="images/about-2.png" alt="about" />
          </div>
          <div className="col-xl-7 col-lg-7 col-md-12 order-t-1" data-aos="fade-left">
            <div className="heading">
                <div>
                    <img src="images/testimonial.png" alt="Testimonial Icon" className="testimonial-icon" />
                    <p className="text-uppercase m-0">What Made Us Start Wheat Bakes?</p>
                </div>

              <h1 className="mb-4">"Amma, where do I find cakes that are healthy?"</h1>
            </div>

            <div className="content">
              <p className="fw-semibold wheatbakes-para-justify">
                A few years ago, my son asked me this simple yet profound question when he wanted a chocolate cake, and I refused, saying cakes were unhealthy. His question left me speechless and sparked a realization: there were no nearby stores or bakeries offering truly healthy cakes.
              </p>

              <p className="fw-semibold wheatbakes-para-justify">
                This moment marked the beginning of Wheat Bakes. It was born out of a mother's love and a mission to create cakes that are both delicious and nutritious, so no one has to compromise between health and indulgence.
              </p>

              <p className="author">
                - Sai Nirupa, Chief Baking Officer @ Wheat Bakes
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Aboutus;
